import { render, staticRenderFns } from "./productLabelManagement.vue?vue&type=template&id=70e9d93c&scoped=true&"
import script from "./productLabelManagement.vue?vue&type=script&lang=js&"
export * from "./productLabelManagement.vue?vue&type=script&lang=js&"
import style0 from "./productLabelManagement.vue?vue&type=style&index=0&id=70e9d93c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e9d93c",
  null
  
)

export default component.exports